import { ResourceView } from "@ra-data-prisma/dataprovider";
import { gql } from "@apollo/client";

const DeliveryNoteFragment = gql`
  fragment DeliveryNoteFragment on DeliveryNote {
    order {
      id
      integrationType
      referenceOrderNumber
      externalSystemOrderNumberIngres
      externalSystemOrderNumberCarlo
      orderNumber
      loadingDate
      loadingLocationId
      loadingNote
      loadingPostcode
      loadingName
      loadingStreet
      loadingCity
      loadingCountry
      unloadingName
      unloadingStreet
      unloadingCountry
      unloadingCity
      unloadingPostcode
      unloadingDate
      unloadingLocationId
      unloadingNote
      mass
      isMain
      cost
      currency
      numberOfItems
      noteForInvoice
      noteForDispatch
      confirmedAt
      createdAt
    }
    documents {
      id
      path
      type
    }
  }
`;

export const DeliveryNoteResource: ResourceView = {
  resource: "DeliveryNote",
  fragment: {
    one: {
      type: "document",
      mode: "extend",
      doc: DeliveryNoteFragment,
    },
    many: {
      type: "document",
      mode: "extend",
      doc: DeliveryNoteFragment,
    },
  },
};
